import { useState } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import TextField from '@mui/material/TextField';
import { SHORT_MAX_VALUE } from '@Components/Utilities/SandhillsConstants';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const BuyersPremiumForm = (props) => {

    const [buyersPremiumModal_State, setBuyersPremiumModal_State] = useState({
        quantity: 1,
        price: ''
    });
    const routes = useRecoilValue(atoms.routes);

    function getBuyersPremiumCalculation() {
        sandhillsRequest({
            url: routes.GetBuyersPremiumCalculation,
            data: {
                listingID: props.ListingID,
                currencyCode: props.CurrencyCode,
                price: buyersPremiumModal_State.price,
                quantity: buyersPremiumModal_State.quantity
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setBuyersPremiumModal_State({ ...buyersPremiumModal_State, calcResult: data });
        });
    }

    return (
        <div id='buyers-premium-form' className='buyers-premium-form'>
            <div className='form-main-content'>
                <div className='content-wrapper'>
                    <div className='addtional-fees'>
                        {(props.OverallCap || props.InternetOnlyFee || props.AdditionalFee) &&
                            <>
                                {props.OverallCap &&
                                    <div className='bold center'>
                                        <TranslationText tKey='Sandhills.PerListingCap' />: <span className='red-text'>{props.OverallCap}</span>
                                    </div>}
                                {props.InternetOnlyFee &&
                                    <div className='bold center'>
                                        <TranslationText tKey='Sandhills.InternetBidderFee' />: <span className='red-text'>{props.InternetOnlyFee}</span>
                                        {props.InternetFeeCap &&
                                            <span> <TranslationText tKey='Sandhills.CappedAt' />: <span className='red-text'>{props.InternetFeeCap}</span></span>}
                                    </div>}
                                {props.AdditionalFee &&
                                    <div className='bold center'>
                                        <TranslationText tKey='Sandhills.AdditionalFee' />: <span className='red-text'>{props.AdditionalFee}</span>
                                        {props.AdditionalFeeCap &&
                                            <span> <TranslationText tKey='Sandhills.CappedAt' />: <span className='red-text'>{props.AdditionalFeeCap}</span></span>}
                                    </div>}
                                <hr />
                            </>}
                    </div>
                    <div>
                        <div >
                            <div className='cf form-header mobile-hide bp-headers'>
                                <div>
                                    <strong><TranslationText tKey='Sandhills.AuctionWinningBid' /></strong>
                                </div>
                                {props.HasRangeWithChargeAmount &&
                                    <div>
                                        <strong><TranslationText tKey='Sandhills.Premium' />
                                            {props.InternetBidderCap && <span><br /><TranslationText tKey='Sandhills.CappedAt' /> {props.InternetBidderCap}</span>}
                                        </strong>
                                    </div>}
                                {(!props.InternetOnlyFee && props.HasRangeWithInternetFee) &&
                                    <div>
                                        <strong><TranslationText tKey='Sandhills.internetbidderfee' />
                                            {props.InternetFeeCap && <span><br /><TranslationText tKey='Sandhills.CappedAt' /> {props.InternetFeeCap}</span>}
                                        </strong>
                                    </div>}
                                {(!props.AdditionalFee && props.HasRangeWithAdditionalFee) &&
                                    <div>
                                        <strong><TranslationText tKey='Sandhills.additionalfee' />
                                            {props.AdditionalFeeCap && <span><br /><TranslationText tKey='Sandhills.CappedAt' /> {props.AdditionalFeeCap}</span>}
                                        </strong>
                                    </div>}
                            </div>
                            {props.PremiumRanges && props.PremiumRanges.length > 0 && props.PremiumRanges.map((range, index) =>
                                <div key={(index + range.WinningBidRange)} className='cf form-el'>
                                    <span className='desktop-hide'><strong><TranslationText tKey='Sandhills.AuctionWinningBid' /></strong></span>
                                    <div> {range.WinningBidRange} </div>
                                    {props.HasRangeWithChargeAmount && <>
                                        <span className='desktop-hide'>
                                            <strong><TranslationText tKey='Sandhills.Premium' /></strong>
                                            {props.InternetBidderCap && <span>: <TranslationText tKey='Sandhills.CappedAt' /> {props.InternetBidderCap}</span>}
                                        </span>
                                        <div> {range.BuyersPremiumFee} </div>
                                    </>}
                                    {(!props.InternetOnlyFee && props.HasRangeWithInternetFee) && <>
                                        <span className='desktop-hide'>
                                            <strong><TranslationText tKey='Sandhills.internetbidderfee' /></strong>
                                            {props.InternetFeeCap && <span>: <TranslationText tKey='Sandhills.CappedAt' /> {props.InternetFeeCap}</span>}
                                        </span>
                                        <div> {range.InternetOnlyFee} </div>
                                    </>}
                                    {(!props.AdditionalFee && props.HasRangeWithAdditionalFee) && <>
                                        <span className='desktop-hide'>
                                            <strong><TranslationText tKey='Sandhills.additionalfee' /></strong>
                                            {props.AdditionalFeeCap && <span>: <TranslationText tKey='Sandhills.CappedAt' /> {props.AdditionalFeeCap}</span>}
                                        </span>
                                        <div> {range.AdditionalFee} </div>
                                    </>}
                                </div>)}
                        </div>
                        {props.IsStacked && <div className='premium-is-stacked center'><i><TranslationText tKey='Sandhills.PremiumIsStacked' /></i></div>}
                    </div>
                    {props.showCalculator &&
                        <>
                            <br />
                            <br />
                            <div id='BuyersPremiumCalculationOut' className='red bold'></div>
                            <div id='BuyersPremiumCalculationInput'>
                                {buyersPremiumModal_State.calcResult && <>
                                    <div className='center red-text'><TranslationText tKey='Sandhills.CalculatedPrice' />: {buyersPremiumModal_State.calcResult}</div><br />
                                </>}
                                <div className='center'><strong><TranslationText tKey='Sandhills.CalculateAPremium' /></strong></div><br />
                                <div className='column6 left'>
                                    <TextField
                                        variant="standard"
                                        id='inBuyersPremiumSoldPrice'
                                        placeholder='Enter Sold Price'
                                        value={buyersPremiumModal_State.price}
                                        inputProps={{
                                            type: 'numeric',
                                            min: 1,
                                            max: 79228162514264337593543950335
                                        }}
                                    onChange={(e) => setBuyersPremiumModal_State({ ...buyersPremiumModal_State, price: (e?.target?.value && !isNaN(e.target.value) ? parseFloat(e.target.value) : '') })}
                                    />
                                </div>
                                <div className='column6 left lh-2'>
                                    <div className='column3 left'><TranslationText tKey='Sandhills.quantity' />: </div>
                                    <div className='column6 left'>
                                        <TextField
                                            variant="standard"
                                            placeholder='Enter Quantity'
                                            value={buyersPremiumModal_State.quantity}
                                            inputProps={{
                                                type: 'numeric',
                                                min: 1,
                                                max: 32767,
                                                pattern: '[0-9]*'
                                            }}
                                            onChange={(e) => setBuyersPremiumModal_State({ ...buyersPremiumModal_State, quantity: ((e?.target?.value && !isNaN(e.target.value) && parseInt(e.target.value) <= SHORT_MAX_VALUE) ? parseInt(e.target.value) : '') })}
                                        />
                                    </div>
                                <div className='column3 left'><button className='btn-form btn ts-button template-branded-button' onClick={() => getBuyersPremiumCalculation()}>Calculate</button></div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export default BuyersPremiumForm;